/* tslint:disable */

export enum OrganisationsWithReferencesTo {
  Components = 0,
  Guidelines = 2,
  Smartbooks = 3,
}
